import { BusinessDocumentSetting } from '@/features/business_document_setting';
import { FC } from 'react';
const BusinessDocumentSettingPage: FC = () => {
  return <BusinessDocumentSetting />;
};

export default BusinessDocumentSettingPage;
